module.exports = __webpack_public_path__ + "img/auto-check-mobile.dc233b46.png";